import { useState, useEffect } from 'react';
import {
  dataTableThClass,
  dataTableTheadRowClass,
} from '../../../components/ui/DataTable';

interface DashboardTableHeaderProps {
  allChecked: boolean;
  onCheckAll: (checked: boolean) => void;
}

export default function DashboardTableHeader({
  allChecked,
  onCheckAll,
}: DashboardTableHeaderProps) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authData = localStorage.getItem('auth');
      if (authData) {
        const parsedData = JSON.parse(authData);
        setIsAdmin(parsedData.user?.role === 'admin');
      }
    } catch (error) {
      console.error('Error reading localStorage:', error);
    }
  }, []);

  return (
    <thead>
      <tr className={dataTableTheadRowClass}>
        {isAdmin && (
          <th className={dataTableThClass}>
          <input
            className="w-4 h-4 rounded border-neutral-300 text-primary-700 focus:border-primary-700"
            type="checkbox"
            checked={allChecked}
            onChange={e => onCheckAll(e.target.checked)}
            aria-label="Select all pitches"
          />
        </th> ) }
        {isAdmin && <th className={dataTableThClass}>Company</th>}
        <th className={dataTableThClass}>Artist</th>
        <th className={dataTableThClass}>Release</th>
        <th className={dataTableThClass}>Date</th>
        <th className={dataTableThClass}>Pitch Due</th>
        {isAdmin && <th className={dataTableThClass}>Date Submission</th> }
        <th className={dataTableThClass}>Pitch Status</th>
        <th className={dataTableThClass}>Action</th>
      </tr>
    </thead>
  );
}